import script from "./ReportPagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReportPagination.vue?vue&type=script&lang=ts&setup=true"

import "./ReportPagination.vue?vue&type=style&index=0&id=2962fd5e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2962fd5e"]])

export default __exports__